import React from "react";
import { Col, Form, Input, Modal, Row, theme } from "antd";
import { SUCCESS_COLOR } from "../../constants/color";
import { PATCH, POST } from "../../frameworks/HttpClient";
import {URL_SKIM } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";

export default function AddSkimChemicalModal(props) {

  const { open, onClose, target, onUpdate} = props;
  const [loading, setLoading] = React.useState(false);
  const [ errorMessages, setErrorMessages ] = React.useState(null);
  const [form] = Form.useForm();
  const isCreate = target === 'add'

  const {
    token: { colorWarning },
  } = theme.useToken();

  const handleOk = async() => {
    setLoading(true)
    setErrorMessages(null)
    try {
      const data = await form.validateFields()
      if(isCreate){
        await POST(URL_SKIM.SKIM_CHEMICAL, data)
      } else {
        await PATCH(`${URL_SKIM.SKIM_CHEMICAL}${target.id}/`, data)
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if(open){
      if(isCreate){
        form.resetFields();
      } else {
        form.setFieldsValue(target)
      }
    }
  },[open])

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

	return(
    <Modal
      open={open}
      onCancel={onClose}
      okText={isCreate ? "ตกลง" : "แก้ไข"}
      okButtonProps={{ style: { backgroundColor : isCreate ? SUCCESS_COLOR : colorWarning}, loading: loading }}
      cancelText={"ไม่"}
      cancelButtonProps={{ loading: loading }}
      title={isCreate ? "เพิ่มชื่อสารเคมีสกิม" : "แก้ไขชื่อสารเคมีสกิม"}
      width={500}
      onOk={handleOk}
    >
      <ErrorMessages message={errorMessages}/>
      <Form
        form={form}
        layout={'vertical'}
      >
        <Row>
          <Col span={24}>
            <Form.Item 
              label={'ชื่อสารเคมีสกิม'}
              style={{marginRight : 10}}
              name={"name"}
              rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Input style={{ width : '100%' }} placeholder={'ชื่อสารเคมีสกิม'}/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
)
}